// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YdG4j","largestCol":"styles_largestCol__15E2e","smallestCol":"styles_smallestCol__tYso5"};